import { React } from 'react';

import './index.scss';



const CheckBox = ({inputLabel, checkBoxValue, handleCheckboxChange, disable, isChecked}) => {
    
    const handleOnChange = (e)=> {
        e.stopPropagation();
        handleCheckboxChange(e)
    }

    const handleOnClick = (e) => {
        e.stopPropagation(); // Prevent parent onClick
    };

    return (
        <div>
            <label className="checkbox-component" onClick={handleOnClick}>
                {inputLabel}
                <input type="checkbox" disabled={disable} checked={isChecked} value={checkBoxValue} onChange={handleOnChange}/>
                <span className="checkmark"></span>
            </label>
        </div>
    )
}

export default CheckBox;